<template>
  <div class="employees-table">
    <app-table-dropdown
      route=""
      :isHeaderLink="false"
      :response="response || []"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span class="app-table-dropdown__table-header-title"
            >ФИО сотрудника</span
          >
          <span class="app-table-dropdown__table-header-title">Должность</span>
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title"
            >Подписант</span
          >
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title"
          ></span>
        </div>
      </template>

      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div class="app-table-dropdown__row-header-default-item">
            {{ `${item.lastName} ${item.firstName} ${item.middleName}` }}
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.position.name }}
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.isSigner ? 'Да' : 'Нет' }}
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item"
          ></div>
        </div>
      </template>

      <template #row-body="{ item }">
        <div
          class="app-table-dropdown__row-body-default app-table-dropdown__container"
        >
          <div class="app-table-dropdown__row-body-content">
            <ul
              class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
            >
              <li v-if="item.firstName" class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Имя
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.firstName }}
                </p>
              </li>
              <li v-if="item.middleName" class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Отчество
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.middleName }}
                </p>
              </li>
              <li v-if="item.lastName" class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Фамилия
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.lastName }}
                </p>
              </li>
              <li v-if="item.gender" class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Пол
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.gender === 'F' ? 'Женский' : 'Мужской' }}
                </p>
              </li>
              <li class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Подписант
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.isSigner ? 'Да' : 'Нет' }}
                </p>
              </li>
            </ul>
            <ul
              class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
            >
              <li
                v-if="item.position.name"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Должность
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.position.name }}
                </p>
              </li>
              <li
                v-if="item.position.activeFrom"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Дата
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.position.activeFrom | dateFormat() }}
                </p>
              </li>
              <li
                v-if="item.position.credentials.type"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Полномочия
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.position.credentials.type }}
                </p>
              </li>
              <li
                v-if="item.position.credentials.number"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Номер документа
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.position.credentials.number }}
                </p>
              </li>
              <li
                v-if="item.position.credentials.date"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Дата документа
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.position.credentials.date | dateFormat() }}
                </p>
              </li>
            </ul>
            <div
              class="app-table-dropdown__row-body-default-item app-table-dropdown__empty-column"
            ></div>
          </div>
          <div class="app-table-dropdown__row-body-btn-block">
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              @click="$emit('open-edit', item.uuid)"
            >
              Редактировать сотрудника
            </app-button-control>
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              v-if="!item.isSigner"
              @click="$emit('make-signer', item.uuid)"
            >
              Назначить подписантом
            </app-button-control>
          </div>
        </div>
      </template>

      <template #portal="{ item }">
        <app-curtain-header
          title="Информация о водителе"
          class="main-curtain-header"
        ></app-curtain-header>
        <div class="app-table-dropdown__portal main-curtain-body">
          <ul
            class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
          >
            <li v-if="item.firstName" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Имя
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.firstName }}
              </p>
            </li>
            <li v-if="item.middleName" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Отчество
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.middleName }}
              </p>
            </li>
            <li v-if="item.lastName" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Фамилия
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.lastName }}
              </p>
            </li>
            <li v-if="item.gender" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Пол
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.gender === 'F' ? 'Женский' : 'Мужской' }}
              </p>
            </li>
            <li class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Подписант
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.isSigner ? 'Да' : 'Нет' }}
              </p>
            </li>
            <li v-if="item.position.name" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Должность
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.position.name }}
              </p>
            </li>
            <li
              v-if="item.position.activeFrom"
              class="app-table-dropdown__list-item"
            >
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Дата
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.position.activeFrom | dateFormat() }}
              </p>
            </li>
            <li
              v-if="item.position.credentials.type"
              class="app-table-dropdown__list-item"
            >
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Полномочия
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.position.credentials.type }}
              </p>
            </li>
            <li
              v-if="item.position.credentials.number"
              class="app-table-dropdown__list-item"
            >
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Номер документа
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.position.credentials.number }}
              </p>
            </li>
            <li
              v-if="item.position.credentials.date"
              class="app-table-dropdown__list-item"
            >
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Дата документа
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.position.credentials.date | dateFormat() }}
              </p>
            </li>
          </ul>

          <div class="app-table-dropdown__portal-footer">
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              @click="$emit('open-edit', item.uuid)"
            >
              Редактировать сотрудника
            </app-button-control>
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              v-if="!item.isSigner"
              @click="$emit('make-signer', item.uuid)"
            >
              Назначить подписантом
            </app-button-control>
          </div>
        </div>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
export default {
  name: 'EmployeesTable',
  inject: ['responsive'],
  components: {
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppCurtainHeader: () => import('@/components/common/AppCurtainHeader'),
  },
  props: {
    response: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.employees-table {
  // -
}
</style>
